import { DITypes } from "@/core/@types/types";
import { F360UnitDate, type IF360Date } from "@/core/plugins/date/F360Date";
import { injectable, inject } from "inversify";
import { IPrazoHandler } from "./PrazoHandler";
import "reflect-metadata";

@injectable()
export default class PrazoFaturamentoHandler implements IPrazoHandler {
  @inject(DITypes.DATE) private libDate!: IF360Date;

  private readonly day = 20;

  private handleSubtractMonths(date: Date) {
    // se é após o dia 20, são 1 mes atrás para ser comparado, quando não, 2 meses
    return date.getDate() > this.day ? 1 : 2;
  }

  handlePrazo(date: Date) {
    const current = this.libDate.now();

    const currentDateWithSubtractedMonths = this.libDate.subtract(
      current,
      this.handleSubtractMonths(current),
      F360UnitDate.Month
    );

    const year = currentDateWithSubtractedMonths.getFullYear();

    const month = this.libDate.getMonth(currentDateWithSubtractedMonths) + 1;

    const acceptedRange = this.libDate.getNewDate(
      `${year}/${month}/${this.day}`
    );

    const start = this.libDate.getNewDate(
      `${currentDateWithSubtractedMonths.getFullYear()}/${1}/${currentDateWithSubtractedMonths.getDate()}`
    );

    return {
      isValid: this.libDate.isBefore(date, acceptedRange),
      acceptedRange,
      range: {
        start,
        end: acceptedRange
      }
    };
  }
}
